import {
  CONTRIBUTOR_PERMISSION_CHECK_TYPE,
  CONTRIBUTOR_UPLOAD_ACCESS,
  PERMISSION_TYPES,
} from '../../../../../constants/contributors';
import useContributorPermission from './useContributorPermission';

/**
 * Determines whether a user has certain permissions based on their
 * contributor hierarchy.
 *
 * @param {Object} options The option list.
 * @param {String} options.entityId ID of the entity (Album or AlbumFolder) to check permission for.
 * @param {Array<CONTRIBUTOR_UPLOAD_ACCESS>} options.permissions List of dedicated upload permissions to check for. These do *NOT* Require the type.
 * @param {String} options.checkType How to deal with provided permissions. Either Inclusive or exclusive.
 */
const useVideoUploadPermission = ({
  entityId,
  permissions = [
    CONTRIBUTOR_UPLOAD_ACCESS.REVIEW,
    CONTRIBUTOR_UPLOAD_ACCESS.PUBLISH,
  ],
  checkType = CONTRIBUTOR_PERMISSION_CHECK_TYPE.ANY,
  ...opts
}) => {
  return useContributorPermission({
    entityId,
    permissions: permissions.map(permission => ({
      type: PERMISSION_TYPES.UPLOAD_ACCESS,
      permission,
    })),
    checkType,
    ...opts,
  });
};

export default useVideoUploadPermission;
